<template>
	<section>
		<compWrapper :title="$t('fbb.inbound.planned_shipping_information', { defaultValue: '计划发运信息' })" theme="primary">
			<vTableSimple class="margin-layout" :columns="columns" :data="dataList"></vTableSimple>
            <template slot="footer">
                <vButton class="margin-5" @click="back">返回</vButton>
            </template>
		</compWrapper>
		<compWrapper :title="$t('fbb.inbound.packing_information', { defaultValue: '装箱信息' })" theme="primary">
			<compFormEdit col="3" class="margin-layout" :formdata="getBoxBase" ref="box" v-model="formData"></compFormEdit>
			<vButtonGroup class="margin-left-30">
				<vButton theme="primary" @click="addItem">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
				<vButton theme="info" @click="importItems">{{$t('global.common.import', { defaultValue: '导入' })}}</vButton>
				<vButton theme="success" @click="onceBoxing">{{$t('fbb.inbound.click_packing', { defaultValue: '一键装箱' })}}</vButton>
				<vButton theme="warning" @click="importFbaItems" v-if="warehouseType!=2">{{$t('fbb.inbound.import_FBA_information', { defaultValue: '导入FBA装箱信息' })}}</vButton>
			</vButtonGroup>
			<compPackage
				class="margin-layout"
				:startUp="startUp"
				:initFormData="{id:id}"
				status="boxing"
				@on-update="getInboundBillDetail"
				ref="package"
			></compPackage>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
	</section>
</template>

<script>
import {
	HttpInboundBillItem,
	HttpSkuList,
	HttpAddPackage,
	HttpImportPackage,
	HttpOnceBoxingPackage,
	HttpImportFbaPackage,
	HttpDelPackage,
	HttpClearPackage,
	HttpExportPackage,
	HttpProductInfo,
} from '@/service/inbound';
import { mapGetters } from 'vuex';
import compPackage from './package';
// import comExcel from '@components/templates/excelalert'

export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
		compUpload: () => import("@components/templates/upload"),
		compPackage,
        // comExcel
	},
	data() {
		return {
			id: this.$route.query.id,
			warehouseType: this.$route.query.warehouseType,
            isManage: this.$route.query.isManage == 1 ? true : false,
			startUp: 1,
			loading: false,
			dataList: [],
			skuList: [],
			formData: {
				// cartonQty: 1,
			},
			modalProps: {
				show: false,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "",
				width: 1000,
				props: {},
				on: {},
			}
		};
	},
	created() {
		this.getInboundBillDetail();
	},
	computed: {
		getSkuList() {
			return this.dataList.map(item => {
				return {
					label: item.sku,
					value: item.sku,
					attach: {
						...item,
						unPackQty: item.qty - item.qtyPacked
					},
				}
			})
		},
		getBoxBase() {
			return [
				{
					label: "SKU",
					key: "sku",
					tag: "vSelect",
					options: this.getSkuList,
					on: {
						'on-attach': this.getSkuInfo
					},
					span: 5
				}, {
					labelWidth: "auto",
					label: this.$t('fbb.inbound.unbound_no', { defaultValue: "未装箱数量:" }),
					query: true,
					key: 'unPackQty',
					span: 3,
				}, {
					label: this.$t('fbb.inbound.box_in_number', { defaultValue: "装箱入数" }),
					key: "packedQty",
					tag: "vInputNumber",
					props: {
						min: 1,
						math: 'round',
						placeholder: this.$t('fbb.inbound.number_per_case', { defaultValue: '每箱装SKU数量' })
					}
				}, {
					label: this.$t('fbb.inbound.cases', { defaultValue: "箱数" }),
					key: "cartonQty",
					required: false,
					tag: "vInputNumber",
					props: {
						min: 1,
						math: 'round',
						placeholder: this.$t('fbb.inbound.default_one', { defaultValue: '默认为1' })
					}
				}, {
					label: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
					key: "cartonCode",
					required: false,
					props: {
						placeholder: this.$t('fbb.inbound.null_auto_generate', { defaultValue: '不填系统自动生成' })
					}
				}, {
					label: this.$t('fbb.inbound.outer_box_length', { defaultValue: '"外箱长(cm)"' }),
					key: "length",
					props: {
						type: 'number',
						min: 0.0001,
					}
				}, {
					label: this.$t('fbb.inbound_outer_box_width', { defaultValue: "外箱宽(cm)" }),
					key: "width",
					props: {
						type: 'number',
						min: 0.0001,
					}
				}, {
					label: this.$t('fbb.inbound_outer_box_height', { defaultValue: "外箱高(cm)" }),
					key: "height",
					props: {
						type: 'number',
						min: 0.0001,
					}
				}, {
					label: this.$t('fbb.inbound_outer_box_weight', { defaultValue: "外箱毛重(kg)" }),
					key: "weight",
					props: {
						type: 'number',
						min: 0.00001,
					}
				}
			]
		},
		//计划发运信息
		columns() {
			return [{
				title: "No.",
				type: 'index'
			}, {
				title: "SKU",
				key: "sku",
			}, {
				title: this.$t('fbb.inbound.planned_quantity', { defaultValue: "计划数" }),
				key: "qty",
			}, {
				title: this.$t('fbb.inbound.has_usingcontainer', { defaultValue: "已装箱数" }),
				key: "qtyPacked",
			}, {
				title: this.$t('fbb.inbound.unbound_no', { defaultValue: "未装箱数" }),
				key: "qtyPacked",
				render(h, { row }) {
					return row.qty - row.qtyPacked
				},
			}];
		},

	},
	methods: {
		// 获取sku信息
		getSkuInfo(attach) {
			return HttpProductInfo({ id: attach.productId }).then(res => {
				const data = res.data || {};
				this.formData = {
					packedQty: data.packedQty,
					unPackQty: attach.unPackQty,
					sku: attach.sku,
					weight: data.packedWeight / 1000,
					height: data.packedHeight,
					length: data.packedLength,
					width: data.packedWidth,
				}

			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//计划发运信息
		getInboundBillDetail() {
			this.loading = true;
			HttpInboundBillItem({ id: this.id }).then(res => {
				this.loading = false;
				this.dataList = res.data;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},

		// 装箱界面SKU下拉列表
		// getSkuList() {
		// 	HttpSkuList({ id: this.id }).then(res => {
		// 		this.skuList = res.data;
		// 	}).catch(err => {
		// 		// this.$VMessage.error(err.message);
		// 	})
		// },
		//添加
		async addItem() {
			const bool = await this.$refs.box.validate();
			if (!bool) {
				this.$VMessage.warning(this.$t('fe.form.require'));
				return;
			}
			this.loading = true;
			const { weight = 0 } = this.formData;
			HttpAddPackage({
				packedQty: 1,
				...this.formData,
				weight: weight * 1000,
				id: this.id
			}).then(res => {
				this.startUp += 1;
				this.formData = {};
				this.getInboundBillDetail();

			}).catch(err => {
				this.$VMessage.error(err.message);
				this.loading = false;
			})
		},
		importItems() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "compUpload",
				width: 520,
				props: {
					ajaxRequest: HttpImportPackage,
					data: { id: this.id },
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/inbound_boxing.xls", {}, {
							executor: 'download',
							type: 'url'
						});
					},
				},
				on: {
					'on-success': (row) => {
						this.startUp += 1;
						this.modalProps.show = false;
						this.getInboundBillDetail();
					}
				},
			}
		},
		// 一键装箱
		onceBoxing() {
			this.loading = true;
			HttpOnceBoxingPackage({ id: this.id }).then(res => {
                // this.modalProps = {
                //     title: '一键装箱',
                //     show: true,
                //     width: 560,
                //     component: "comExcel",
                //     showFooter: false
                // }
				this.loading = false;
				this.$VMessage.success(this.$t('fbb.inbound.async_task', { defaultValue: `异步任务【任务编号${res.data.taskNo}】已生成，请到任务中心查看处理进度及结果！`, taskNo: res.data.taskNo }));
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//导入FBA装箱信息
		importFbaItems() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.import_FBA_information', { defaultValue: '导入FBA装箱信息' }),
				component: "compUpload",
				width: 520,
				props: {
					ajaxRequest: HttpImportFbaPackage,
					data: { id: this.id },
					name: "multipartFile",
					// download() {
					// 	this.handleWebfs("/static/template/inbound_boxing.xls", {}, {
					// 		executor: 'download',
					// 		type: 'url'
					// 	});
					// },
				},
				on: {
					'on-success': (row) => {
						this.startUp += 1;
						this.modalProps.show = false;
					}
				},
			}
		},
		//删除装箱
		removeItems() {
			HttpDelPackage({ id: this.id, boxItemIds: this.$refs.package.checkedData }).then(res => {
				this.startUp += 1;
			}).catch(err => {
				this.$VMessage.error(err.message);
			})

		},
		//清空装箱
		clearAll() {
			HttpClearPackage({ id: this.id }).then(res => {
				this.startUp += 1;
			}).catch(err => {
				this.$VMessage.error(err.message);
			})
		},
		// 导出
		exportPackage() {
			this.handleWebfs(HttpExportPackage, { ...this.$refs.package.formData, inboundPlanOrderId: this.id }, { executor: 'request', download: true });
		},
        back () {
            let name = "inboundBillclientDetail";
            if (this.isManage) {
                name = "inboundBillmanageDetail";
            }
            this.$router.push({
                name: name,
                query: { id: this.id, type: this.isManage ? 'manage' : null },
                params: { type: 'query' }
            });
        },



	}
};
</script>
